import { render } from "./input.vue?vue&type=template&id=4b047f75"
import script from "./input.vue?vue&type=script&lang=ts"
export * from "./input.vue?vue&type=script&lang=ts"
script.render = render

export default script